import { render, staticRenderFns } from "./RoleName.vue?vue&type=template&id=bece8e00&"
import script from "./RoleName.vue?vue&type=script&lang=ts&"
export * from "./RoleName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports